import cloneDeep from 'lodash/cloneDeep';
import { CONTRAT_ETAT_BROUILLON } from '@/configuration/baux/contrat/contratConf';
import { ETAT_ENATTENTE } from '@/configuration/devisConf';
import getDifferenceBetweenDateYearsMonthsDays
  from '@/services/general/getDifferenceBetweenDateYearsMonthsDays';
import addDaysMonthsYearsToDate from '@/services/general/addDaysMonthsYearsToDate';
import genererIntervenantContrat from '@/services/baux/contrat/genererIntervenantContrat';

export default function genererRenouvellementContrat(contrat, nbAnneeRenouvellement) {
  const newContrat = cloneDeep(contrat);
  newContrat.tacite = false;
  newContrat.etatRenouvellement = ETAT_ENATTENTE;
  newContrat.intervenants.push(genererIntervenantContrat());
  if (!newContrat.contratInitialId) newContrat.contratInitialId = newContrat.id;
  delete newContrat.id;
  newContrat.ordreRenouvellement += 1;
  newContrat.echeancier = [];
  newContrat.etat = CONTRAT_ETAT_BROUILLON;
  let dureeContrat = null;
  if (nbAnneeRenouvellement) {
    dureeContrat = {
      years: nbAnneeRenouvellement,
      months: 0,
      day: 0,
    };
  } else {
    dureeContrat = getDifferenceBetweenDateYearsMonthsDays(
      newContrat.dateDebutSignature, newContrat.dateFinSignature,
    );
  }
  newContrat.dateDebutSignature = addDaysMonthsYearsToDate(newContrat.dateFinSignature, {
    days: 1, months: 0, years: 0,
  });
  newContrat.dateFinSignature = addDaysMonthsYearsToDate(newContrat.dateFinSignature, dureeContrat);
  newContrat.datePreavis = addDaysMonthsYearsToDate(newContrat.datePreavis, dureeContrat);
  newContrat.dateDebutEcheance = addDaysMonthsYearsToDate(
    newContrat.dateFinEcheance, { days: 1, months: 0, years: 0 },
  );
  newContrat.dateFinEcheance = addDaysMonthsYearsToDate(newContrat.dateFinEcheance, dureeContrat);
  if (newContrat.secteur) {
    delete newContrat.secteur.id;
    delete newContrat.secteur.contratId;
  }
  return newContrat;
}
